import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { UserType } from '../../../Shared/Enums/UserType';

@Component({
  selector: 'app-choose-contract',
  templateUrl: './choose-contract.component.html',
  styleUrl: './choose-contract.component.scss'
})
export class ChooseContractComponent {
  @Input() Contract?: DtoContractClientForViewVM;
  @Output() chooseContract = new EventEmitter<boolean>();
  formErrors: string[] = [];
  imageUrls: string[] = [];

  constructor(private auth: AuthService, private router: Router,
    private spinner: NgxSpinnerService, private translate: TranslateService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      //this.spinner.show();
      //console.log(this.Contract);

    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    this.chooseContract.emit(false);
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result != null) {
          this.imageUrls.push(reader.result.toString());
        }
      };
      reader.readAsDataURL(file);
    }
  }

  ViewWarrantyBeforeSend() {
    this.formErrors = [];
    const errors = [];
    let isNotValid = false;
    if (this.imageUrls.length == 0) {
      errors.push('UploadImagesError');
      isNotValid = true;
    }

    if (isNotValid) {
      errors.forEach(item => {
        this.formErrors.push(this.translate.instant(item));
      });

      return;
    }

    this.SumbitViewWarrantyBeforeSend();
  }

  SumbitViewWarrantyBeforeSend() {

  }
}
